/** @file Carries out one pointer effect: commit through the ports, selection, axes or playhead. */
import { playhead } from '../../playback/playhead';
import type { CurvePointerEffect } from './curvePointer';
import type { CurvePorts } from './curvePorts';
import type { CurveRef } from './curveTypes';
import { curveViewStore } from './curveViewStore';
import { writeCurveSelection } from './writeCurveSelection';

/** `shown` = the refs on screen (pinned when the graph rewrites the key selection). */
export function applyCurveEffect(effect: CurvePointerEffect, ports: CurvePorts, shown: readonly CurveRef[]): void {
  switch (effect.kind) {
    case 'commit':
      ports.commit(effect.calls);
      return;
    case 'select':
      writeCurveSelection(effect.keys, effect.add, shown);
      curveViewStore.setState({ active: effect.active });
      return;
    case 'axes':
      curveViewStore.setState(effect.axes);
      return;
    case 'scrub':
      playhead.setFrame(effect.frame);
      return;
  }
}
